/* WOZ V43 — product hero scale, story scroll effects, terminal typing */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vh = function () { return window.innerHeight || document.documentElement.clientHeight; };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  function headerOffset() {
    var h = document.querySelector('.site-header-container');
    var px = h ? Math.round(h.getBoundingClientRect().height) : 52;
    document.documentElement.style.setProperty('--v43-header', px + 'px');
  }

  /* --- videos: play only when visible; pause toggle --- */
  function videos() {
    var vids = [].slice.call(document.querySelectorAll('[data-v43-video]'));
    if (!vids.length) return;
    if (reduce) { vids.forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); var b = v.parentNode.querySelector('[data-v43-toggle]'); if (b) { b.classList.add('is-paused'); b.setAttribute('aria-label', 'Play video'); } }); }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        var v = e.target;
        if (v.dataset.userPaused === '1' || reduce) return;
        if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 }) : null;
    vids.forEach(function (v) {
      if (io) io.observe(v);
      var btn = v.parentNode.querySelector('[data-v43-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (v.paused) { v.dataset.userPaused = '0'; v.play(); btn.classList.remove('is-paused'); btn.setAttribute('aria-label', 'Pause video'); }
        else { v.dataset.userPaused = '1'; v.pause(); btn.classList.add('is-paused'); btn.setAttribute('aria-label', 'Play video'); }
      });
    });
  }

  /* --- statement words --- */
  function splitWords() {
    document.querySelectorAll('[data-v43-words]').forEach(function (el) {
      if (el.dataset.split) return; el.dataset.split = '1';
      var words = el.textContent.trim().split(/\s+/);
      el.setAttribute('aria-label', el.textContent.trim());
      el.innerHTML = words.map(function (w) { return '<span class="w" aria-hidden="true">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
    });
  }

  /* --- terminal typing --- */
  function typers() {
    var els = [].slice.call(document.querySelectorAll('[data-v43-type]'));
    if (!els.length) return;
    var run = function (el) {
      var t = el.getAttribute('data-v43-type') || '';
      if (reduce) { el.textContent = t; return; }
      var i = 0; el.textContent = '';
      (function step() { el.textContent = t.slice(0, ++i); if (i < t.length) setTimeout(step, 38 + Math.random() * 40); })();
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } }); }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- scroll frame --- */
  var scales, rises, words, zooms, ticking = false;
  function collect() {
    scales = [].slice.call(document.querySelectorAll('[data-v43-scale]'));
    rises = [].slice.call(document.querySelectorAll('[data-v43-rise]'));
    words = [].slice.call(document.querySelectorAll('[data-v43-words]'));
    zooms = [].slice.call(document.querySelectorAll('[data-v43-zoom]'));
  }
  function frame() {
    ticking = false;
    var H = vh();
    scales.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = clamp((H - r.top) / (H * 0.9), 0, 1); /* 0 when top at bottom of viewport */
      el.style.setProperty('--v43-s', (0.86 + 0.14 * p).toFixed(4));
    });
    rises.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = clamp((H - r.top) / (H * 0.55), 0, 1);
      el.style.setProperty('--v43-r', ((1 - p) * 40).toFixed(1) + 'px');
      el.style.setProperty('--v43-o', (0.35 + 0.65 * p).toFixed(3));
    });
    words.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = clamp((H * 0.85 - r.top) / (r.height + H * 0.35), 0, 1);
      var ws = el.querySelectorAll('.w'), n = ws.length;
      for (var i = 0; i < n; i++) {
        var local = clamp(p * (n + 4) - i, 0, 1);
        ws[i].style.setProperty('--o', (0.18 + 0.82 * local).toFixed(3));
      }
    });
    zooms.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var total = r.height - H;
      var p = clamp(-r.top / (total || 1), 0, 1);
      var img = el.querySelector('.v43-zoom__img');
      if (img) img.style.setProperty('--v43-z', (1 + 0.9 * Math.min(p / 0.7, 1)).toFixed(4));
      el.style.setProperty('--v43-co', clamp((p - 0.35) / 0.3, 0, 1).toFixed(3));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  function init() {
    headerOffset();
    splitWords(); videos(); typers(); collect();
    if (reduce) return;
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { headerOffset(); onScroll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
